"use client";

import Image from "next/image";
import Link from "next/link";
import { DropdownLanguage } from "./dropdown/language";
import { DropdownProfile } from "./dropdown/profile";
import { useAppSettings } from "@/shared";

export function AdminHeader() {
  const { settings, updateSettings } = useAppSettings();

  const toggleAppSidebarEnd = (e: React.MouseEvent) => {
    e.preventDefault();

    updateSettings({
      appSidebarEndToggled: !settings.appSidebarEndToggled,
    });
  };

  const toggleAppSidebarEndMobile = (e: React.MouseEvent) => {
    e.preventDefault();

    updateSettings({
      appSidebarEndMobileToggled: true,
    });
  };

  const toggleAppSidebarMobile = () => {
    updateSettings({
      appSidebarMobileToggled: true,
    });
  };

  const toggleAppTopMenuMobile = () => {
    updateSettings({
      appTopMenuMobileToggled: true,
    });
  };

  return (
    <div
      id="header"
      className="app-header"
      data-bs-theme={settings.appHeaderInverse ? "dark" : ""}
    >
      <div className="navbar-header">
        <button
          type="button"
          className="navbar-mobile-toggler"
          onClick={toggleAppSidebarMobile}
        >
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>

        <Link href="/admin/main" className="navbar-brand">
          <div className="relative w-24 h-5 flex">
            <Image
              src="/assets/images/logo/headBlackLogo.svg"
              alt="Symbol Logo"
              fill
              style={{ objectFit: "contain" }}
            />
          </div>
          {/* <span className="navbar-logo"></span> <b>Color</b> Admin */}
          {/* <span className="navbar-logo"></span> <b>위즈온</b> */}
        </Link>

        <div className="navbar-nav navbar-right border-0">
          {settings.appHeaderLanguageBar && <DropdownLanguage />}

          <DropdownProfile />

          {settings.appSidebarTwo && (
            <div className="navbar-divider d-none d-md-block"></div>
          )}

          {settings.appSidebarTwo && (
            <div className="navbar-item d-none d-md-block">
              <Link
                href="/"
                onClick={toggleAppSidebarEnd}
                className="navbar-link icon"
              >
                <i className="fa fa-th"></i>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
